exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1wh3g_eLa97bS8{min-height:600px}.eipsAuGItc7Ub5{margin:0;position:absolute;right:8px;top:8px}", ""]);

// exports
exports.locals = {
	"mirrorCard": "_1wh3g_eLa97bS8",
	"closeButton": "eipsAuGItc7Ub5"
};